import React from 'react';
import { inputClass } from './PageHeader';
import { combineDatetime, splitDatetime } from '../utils/datetime';

const DateTimeFields = ({ label, value, onChange, className = '' }) => {
  const { date, time } = splitDatetime(value);

  return (
    <div className={className}>
      {label && <span className="block text-sm font-medium mb-1">{label}</span>}
      <div className="flex gap-2">
        <input
          type="date"
          className={inputClass}
          value={date}
          onChange={(e) => onChange(combineDatetime(e.target.value, time))}
          aria-label={label ? `${label} date` : 'Date'}
        />
        <input
          type="time"
          className={inputClass}
          value={time}
          onChange={(e) => onChange(combineDatetime(date, e.target.value))}
          aria-label={label ? `${label} time` : 'Time'}
        />
      </div>
    </div>
  );
};

export default DateTimeFields;
